/*
<custom-tab-switch>
    <div data-tab-wrapper>
        <div data-tab data-active></div>
        <div data-tab></div>
    </div>
    <div data-tab-content-wrapper>
        <div data-for-tab data-active></div>
        <div data-for-tab></div>
    </div>
</custom-tab-switch>

*/
if (!customElements.get("custom-tab-switch")) {
    customElements.define(
      "custom-tab-switch",
      class CustomTabSwitch extends HTMLElement {
        constructor() {
          super();
          this.tabs = this.querySelectorAll("[data-tab-wrapper] [data-tab]");
          this.swiperContainer = this.querySelector(".swiper");
          this.swiper = null;
          this.tabContents = this.querySelectorAll(
            "[data-tab-content-wrapper]>[data-for-tab]"
          );
  
          this.activeTab = Array.from(this.tabs).find((tab) =>
            tab.hasAttribute("data-active")
          );
          this.activeTabContent = Array.from(this.tabContents).find(
            (tabContent) => tabContent.hasAttribute("data-active")
          );
          this.addEventListener("switchTab",(e)=>{
            console.log("switchTab",e);
            this.switchTab.bind(this,e.detail.index)();
          });//e.detail -> index
        }
        connectedCallback() {
          
          if(this.swiperContainer && Swiper) {
             this.swiper = new Swiper(this.swiperContainer,{
              slidesPerView: 'auto',
              slidesPerGroup:1,
              slidesPerGroupAuto: true,
              slideToClickedSlide: true,
              spaceBetween: 30
             })
          }

          if (this.tabs.length > 1) {
            console.log("绑定点击事件");
            this.tabs.forEach((tab, index) => {
              tab.addEventListener("click",this.switchTab.bind(this,index) );
            });
          }
        }
 
        switchTab(index) {
          if (this.activeTab) {
            this.activeTab.removeAttribute("data-active");
          }
          if (this.activeTabContent) {
            this.activeTabContent.removeAttribute("data-active");
          }
          if(this.tabs.length > 0){
            
            this.tabs[index].setAttribute("data-active", "");
            this.activeTab = this.tabs[index];
          }
          this.tabContents[index].setAttribute("data-active", "");
          this.activeTabContent = this.tabContents[index];
        }
      }
    );
  }